import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Switch from '@material-ui/core/Switch';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { t, T, translationExists } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import MainButton from '@configuratorware/configurator-frontendgui/Shared/Components/MainButton';
import AnalyticsWrapper from '@configuratorware/configurator-frontendgui/App/Shared/Components/Analytics/AnalyticsWrapper';
import InformationTag from '@configuratorware/configurator-frontendgui/App/Shared/Components/InformationTag/InformationTag';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { combineMediaQueriesWithAnd } from '@configuratorware/configurator-frontendgui/Utils/Styles/combineMediaQueries';
import isArray from 'lodash/isArray';
import get from 'lodash/get';
import { useSelector } from 'react-redux';
import { getConf } from '@configuratorware/configurator-frontendgui/App/configuration';
import PriceList from './PriceList';
import { showReceiveOfferForm } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Selectors';
import { Button } from '@material-ui/core';
import { getSelectedDesignProductionMethodForDesignArea } from '../../Selectors/Selectors';

const useStyles = makeStyles((theme) => {
  const orientation = {
    portrait: '',
    ...theme.orientation,
  };
  return {
    Card: {
      boxShadow: 'none !important',
    },
    ContainerItem: {
      paddingTop: '5px',
    },
    Container: {
      [theme.breakpoints.up('sm')]: {
        paddingRight: '32px',
      },
    },
    DesignAreaContainer: {
      maxHeight: 'calc(100vh - 300px)',
      overflow: 'auto',
      padding: '15px',
      [theme.breakpoints.down('sm')]: {
        maxHeight: 'unset',
      },
    },
    AmountContainer: {
      marginTop: '15px',
      display: 'flex',
      justifyContent: 'center',
      width: 150,
      flexDirection: 'column',
      '& input': {
        textAlign: 'center',
      },
      '& p': {
        fontWeight: '500',
      },
    },
    CalculationWidgetBtn: {
      textTransform: 'none',
      backgroundColor: '#ffffff',
      color: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      borderRadius: 0,
      width: '100%',
    },
    ExpansionPanel: {
      boxShadow: 'none',
      borderBottom: '1px solid ' + theme.palette.primary.main,
      borderBottomLeftRadius: '0px !important',
      borderBottomRightRadius: '0px !important',
      width: '100%',
      minWidth: 150,
    },
    gridItemExpansionPanel: {
      height: 40,
      [combineMediaQueriesWithAnd(orientation.portrait, '@media (max-width: 345px)')]: {
        '& label': {
          marginRight: 0,
        },
      },
    },
    footerButtonsContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: 'column',
      gap: 20,
      width: '100%',
    },
    ExpansionPanelSummary: {
      margin: 0,
      height: 44,
    },
    ExpansionPanelSummaryRoot: {
      minHeight: 44,
      paddingLeft: 12,
      paddingRight: 12,
    },
    ExpansionPanelSummaryExpanded: {
      margin: '0 !important',
      minHeight: '44px !important',
    },
    ExpansionDetailsRoot: {
      padding: '0px 24px 10px',
      [combineMediaQueriesWithAnd(orientation.portrait, '@media (max-width: 325px)')]: {
        padding: '0px 10px 2px',
      },
    },
    designAreaTitle: {
      fontWeight: '500',
      fontSize: 20,
    },
    TypographyTitle: {
      paddingLeft: '16px',
      color: '#464646',
      paddingTop: '16px',
      fontWeight: 'bold',
      fontSize: 32,
    },
    Typography: {
      paddingLeft: '16px',
      color: '#464646',
      paddingTop: '16px',
      fontSize: 20,
    },
    CardContentRoot: {
      padding: '0',
    },
    PriceListContainer: {
      flex: 1,
      '& span': {
        color: '#464646 !important',
        [theme.breakpoints.down('xs')]: {
          fontSize: 12,
        },
      },
    },
    gridItem: {
      width: '100%',
    },
    thumb: {
      width: 12,
      height: 12,
    },
    switchRoot: {
      width: 36,
      padding: 0,
      height: 18,
      marginRight: 12,
    },
    switchBase: {
      color: '#C1C1C3',
      padding: 2,
      '&:hover': {
        color: '#76BCDA',
        '& + $track': {
          backgroundColor: '#D1E9F3',
        },
      },
      '&$checked': {
        color: theme.palette.primary.main,
        '& + $track': {
          backgroundColor: '#D1E9F3',
          opacity: 1,
        },
        '&:hover': {
          color: '#76BCDA',
          '& + $track': {
            backgroundColor: '#D1E9F3',
            opacity: 1,
          },
        },
      },
    },
    checked: {},
    track: {
      borderRadius: 9,
      backgroundColor: '#F1F1F1',
    },
    selectMenu: {
      border: '1px solid black',
      borderRadius: 0,
      '& .MuiSelect-root': {
        padding: 10,
      },
      '& .MuiSelect-select': {
        padding: 10,
        whiteSpace: 'normal',
        lineHeight: 'normal',
        color: '#464646',
        display: 'block',
      },
    },
    summaryContainer: {
      minHeight: 220,
      maxHeight: 'max-content',
      backgroundColor: '#f0f0f0',
      display: 'flex',
      padding: '20px !important',
      flexDirection: 'column',
      width: '100%',
    },
    summaryTypography: {
      fontWeight: 'bold',
      height: 50,
    },
    SaveConfigButton: {
      textTransform: 'none',
      whiteSpace: 'nowrap',
      margin: 0,
      padding: '6px 15px',
      borderRadius: 0,
      width: '100%',
    },
    alignInfoButton: {
      display: 'flex',
      alignItems: 'center',
    },
    gridItemWrapper: {
      padding: '10px 10px 0px',
      overflow: 'hidden',
      flexGrow: 1,
      '& input': {
        textOverflow: 'ellipsis',
      },
    },
    formControl: {
      width: '100%',
      marginBottom: 8,
    },
    underlineInputText: {
      marginBottom: 8,
      //https://github.com/mui-org/material-ui/issues/12192#issuecomment-406182809
      '&&&&:hover:before': {
        borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
      },
      '&:after': {
        borderBottom: '1px solid transparent',
      },
    },
    outlinedInput: {
      cursor: 'default',
    },
    amountContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      marginTop: 15,
      paddingRight: 12,
    },
  };
});

const CalculationWidget = ({
  designAreas,
  amountValue,
  amountError,
  onChangeAmount,
  handleChangeDesignProductionMethod,
  onClickSaveConfiguration,
  onClickPrintConfiguration,
  loaderComponent,
  isSaveButtonEnabled,
  notificationComponent,
  activeDesignAreas = {},
  toggleDesignArea,
  handleChangeDesignArea,
}) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState([]);
  const [value, setValue] = useState(amountValue || 1);
  const configurator = useSelector((state) => state.configurator);
  const { client, calculation } = configurator;
  const userSelectedCalculation = useSelector(
    (state) => state.configurator?.configuration?.customdata?.userSelectedCalculation
  );
  const displayNetPrices = getConf('displayNetPrices', false);
  const query = new URLSearchParams(location.search);
  const hidePrices = query.has('_hide_prices')
    ? query.get('_hide_prices') === '1'
    : client && !!client.hidePrices;

  const handleDesignAreaToggle =
    (designAreaIdentifier) =>
    ({ target: { checked = true } }) => {
      toggleDesignArea?.(designAreaIdentifier, checked);
      if (!checked && expanded.includes(designAreaIdentifier)) {
        setExpanded(expanded.filter((openedPanel) => openedPanel !== designAreaIdentifier));
      }
      if (checked && !expanded.includes(designAreaIdentifier))
        setExpanded([...expanded, designAreaIdentifier]);
    };

  const onChangeDesignProductionMethod = async (designAreaIdentifier, { target: { value } }) => {
    await handleChangeDesignArea(designAreaIdentifier);
    handleChangeDesignProductionMethod?.(value);
  };

  const handlePanelChange = (panel) => (event, isExpanded) => {
    if (isExpanded) {
      setExpanded([...expanded, panel]);
      !activeDesignAreas[panel] && handleDesignAreaToggle(panel)({ target: { checked: true } });
    } else {
      setExpanded(expanded.filter((openedPanel) => openedPanel !== panel));
    }
    handleChangeDesignArea?.(panel);
  };

  const preventPanelSwitch = (evt) => evt.stopPropagation();

  const renderDesignProductionMethodSelect = (designArea) => {
    const designProductionMethods = (designArea.designProductionMethods || []).map((dpm) => ({
      ...dpm,
      name: dpm.title,
    }));
    return (
      <Grid
        item
        className={translationExists('designProductionInformation') ? ' ' + classes.alignInfoButton : ''}
        classes={{ root: classes.gridItemWrapper }}
      >
        <FormControl className={classes.formControl}>
          <AnalyticsWrapper
            targetId="widget_change_design_production_method"
            data={getSelectedDesignProductionMethodForDesignArea(designArea) || ''}
          >
            <Select
              value={getSelectedDesignProductionMethodForDesignArea(designArea)?.identifier || ''}
              onChange={(e) => onChangeDesignProductionMethod(designArea.identifier, e)}
              variant="outlined"
              className={classes.selectMenu}
              MenuProps={{
                PaperProps: {
                  style: {
                    whiteSpace: 'normal',
                  },
                },
              }}
            >
              {designProductionMethods.map((method) => (
                <MenuItem key={method.identifier} value={method.identifier}>
                  {method.name}
                </MenuItem>
              ))}
            </Select>
          </AnalyticsWrapper>
        </FormControl>
        {translationExists('designProductionInformation') && (
          <InformationTag infoText={t('designProductionInformation')} />
        )}
      </Grid>
    );
  };

  const renderDesignProductionMethodValue = (designArea) => {
    const designProductionMethods = (designArea.designProductionMethods || []).map((dpm) => ({
      ...dpm,
      name: dpm.title,
    }));
    return (
      <Grid item classes={{ root: classes.gridItemWrapper }}>
        {designProductionMethods.map((method) => (
          <TextField
            key={method.identifier}
            readOnly
            fullWidth
            value={method.title}
            InputProps={{
              readOnly: true,
              classes: {
                input: classes.outlinedInput,
                underline: classes.underlineInputText,
              },
            }}
          />
        ))}
      </Grid>
    );
  };

  const handleIncrement = () => {
    setValue(value + 1);
    onChangeAmount(value + 1);
  };

  const handleDecrement = () => {
    setValue(value - 1);
    onChangeAmount(value - 1);
  };

  const handleChange = (e) => {
    const newValue = parseInt(e.target.value, 10);
    if (newValue !== value) {
      setValue(isNaN(newValue) ? '' : newValue);
      onChangeAmount(newValue);
    }
  };

  const onBlur = (event) => {
    const {
      target: { value },
    } = event;
    const newValue = parseInt(value);
    if (isNaN(newValue)) {
      setValue(1);
      onChangeAmount(1);
    }
  };

  const positions = get(calculation, 'aggregatedPositions');
  let priceList = [];
  const shippingPrice = displayNetPrices
    ? get(calculation, 'shippingCosts.priceNetFormatted', '')
    : get(calculation, 'shippingCosts.priceFormatted', '');
  const priceFormatted = displayNetPrices
    ? get(calculation, 'totalWithShippingCosts.netTotalFormatted', '')
    : get(calculation, 'totalWithShippingCosts.totalFormatted', '');

  if (isArray(positions)) {
    priceList = positions.map((p) => ({
      key: p.calculationTypeIdentifier,
      selectable: p.selectableByUser,
      selected: get(userSelectedCalculation, p.calculationTypeIdentifier, false),
      label: p.title || t(`calculationTypes.${p.calculationTypeIdentifier}`),
      quantity: p.quantity,
      unitPrice: displayNetPrices ? p.unitPriceNetFormatted : p.unitPriceFormatted,
      price: displayNetPrices ? p.priceNetFormatted : p.priceFormatted,
    }));
  }

  return (
    <div>
      <Card className={classes.Card}>
        <CardContent classes={{ root: classes.CardContentRoot }}>
          {loaderComponent}
          <Grid>
            <Typography className={classes.TypographyTitle} variant="h4">
              {T('calculationWidget.designCalculationTitle1')}
            </Typography>
            <Typography className={classes.Typography} variant="h6">
              {t('calculationWidget.designCalculationTitle2')}
            </Typography>
          </Grid>
          <Grid container spacing={2} className={classes.Container}>
            <Grid item className={classes.gridItem} md={6}>
              <div className={classes.DesignAreaContainer}>
                {designAreas.map((designArea) => (
                  <Grid
                    key={designArea.identifier}
                    className={
                      classes.ContainerItem +
                      (translationExists('designAreaInformation') ? ' ' + classes.alignInfoButton : '')
                    }
                  >
                    <ExpansionPanel
                      className={classes.ExpansionPanel}
                      expanded={expanded.includes(designArea.identifier)}
                      onChange={handlePanelChange(designArea.identifier)}
                    >
                      <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        classes={{
                          content: classes.ExpansionPanelSummary,
                          root: classes.ExpansionPanelSummaryRoot,
                          expanded: classes.ExpansionPanelSummaryExpanded,
                        }}
                      >
                        <Grid item xs={12} className={classes.gridItemExpansionPanel}>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Switch
                              classes={{
                                root: classes.switchRoot,
                                switchBase: classes.switchBase,
                                checked: classes.checked,
                                track: classes.track,
                                thumb: classes.thumb,
                              }}
                              onChange={handleDesignAreaToggle(designArea.identifier)}
                              onClick={preventPanelSwitch}
                              checked={activeDesignAreas[designArea.identifier]}
                            />
                            <Typography variant="body1" className={classes.designAreaTitle}>
                              {designArea.name}
                            </Typography>
                          </div>
                        </Grid>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails classes={{ root: classes.ExpansionDetailsRoot }}>
                        <Grid container>
                          {designArea.designProductionMethods.length > 1
                            ? renderDesignProductionMethodSelect(designArea)
                            : renderDesignProductionMethodValue(designArea)}
                        </Grid>
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                    {translationExists('designAreaInformation') && (
                      <InformationTag infoText={t('designAreaInformation')} />
                    )}
                  </Grid>
                ))}
              </div>
              <div className={classes.amountContainer}>
                <div className={classes.AmountContainer}>
                  <Typography variant="body1">{t('calculationWidget.amount')}</Typography>
                  <AnalyticsWrapper targetId="widget_change_amount" data={amountValue}>
                    <TextField
                      variant="outlined"
                      value={value}
                      error={amountError}
                      onChange={handleChange}
                      onBlur={onBlur}
                      onKeyDown={(event) => {
                        const regEx = /^[0-9\b]+$/;
                        const keyValue = event.key;

                        if (
                          !regEx.test(keyValue) &&
                          keyValue !== 'ArrowLeft' &&
                          keyValue !== 'Backspace' &&
                          keyValue !== 'ArrowRight'
                        ) {
                          event.preventDefault();
                        }
                      }}
                      onFocus={(event) => {
                        event.target.select();
                      }}
                      onPaste={(event) => {
                        event.preventDefault();
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <IconButton onClick={handleDecrement} size="small">
                              <RemoveIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={handleIncrement} size="small">
                              <AddIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </AnalyticsWrapper>
                </div>
              </div>
            </Grid>
            <Grid item className={classes.summaryContainer} md={6}>
              <Typography className={classes.summaryTypography} variant="h6">
                {t('calculationWidget.summary')}
              </Typography>
              {notificationComponent}
              <Grid className={classes.PriceListContainer}>
                <Grid item>
                  <PriceList
                    vatNotice={displayNetPrices ? t('amountPrice.vatNoticeNet') : t('amountPrice.vatNotice')}
                    amount={value}
                    list={priceList}
                    shippingPrice={shippingPrice}
                    totalPrice={priceFormatted}
                    showTotalPrice={true}
                    taxNote={t('amountPrice.vatNotice')}
                    hidePrices={hidePrices}
                    showReceiveOfferForm={
                      query.has('_cta_element')
                        ? query.get('_cta_element') === 'requestOffer'
                        : showReceiveOfferForm(configurator)
                    }
                    productTitle={'title'}
                  />
                </Grid>
              </Grid>
              <div className={classes.footerButtonsContainer}>
                <AnalyticsWrapper targetId="widget_print_view">
                  <Button
                    onClick={onClickPrintConfiguration}
                    className={classes.CalculationWidgetBtn}
                    variant="outlined"
                    size="large"
                  >
                    {t('calculationWidget.printButtonText')}
                  </Button>
                </AnalyticsWrapper>
                <AnalyticsWrapper targetId="widget_open_configurator">
                  <MainButton
                    disabled={!isSaveButtonEnabled}
                    onClick={onClickSaveConfiguration}
                    className={classes.SaveConfigButton}
                    variant="outlined"
                    size="large"
                  >
                    {t('calculationWidget.openConfiguratorButtonText')}
                  </MainButton>
                </AnalyticsWrapper>
              </div>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
};

CalculationWidget.propTypes = {
  classes: PropTypes.object,
  designAreas: PropTypes.array,
  amountValue: PropTypes.number,
  amountError: PropTypes.bool,
  onChangeAmount: PropTypes.func,
  priceListComponent: PropTypes.object,
  handleChangeDesignProductionMethod: PropTypes.func,
  onClickSaveConfiguration: PropTypes.func,
  onClickPrintConfiguration: PropTypes.func,
  loaderComponent: PropTypes.object,
  isSaveButtonEnabled: PropTypes.bool,
  notificationComponent: PropTypes.array,
  activeDesignAreas: PropTypes.object,
  toggleDesignArea: PropTypes.func,
  handleChangeDesignArea: PropTypes.func,
};

export default CalculationWidget;
